import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, Table, Form, Modal } from "react-bootstrap";
import Pagination from "../pagination/Pagination";

const Cabinett = () => {
  const [designations, setDesignations] = useState([]);
  const [newDesignation, setNewDesignation] = useState("");
  const [editId, setEditId] = useState(null);
  const [editDesignation, setEditDesignation] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);

  const [showPerPage] = useState(10)
    const [pagination, setPagination] = useState(
      {
        start: 0,
        end: showPerPage
      }
    )
  
    const onChangePagination = (start, end) => {
      setPagination({ start: start, end: end })
    }

  useEffect(() => {
    fetchDesignations();
  }, []);

  // Fetch designations
const fetchDesignations = async () => {
  const dist = sessionStorage.getItem("dist");
  const res = await axios.get(`https://lionsdirectoryapi.emedha.in/cabinet/api/designations?dist=${dist}`);
  setDesignations(res.data);
};

  // Add designation
const handleAdd = async () => {
  const dist = sessionStorage.getItem("dist");

  await axios.post("https://lionsdirectoryapi.emedha.in/cabinet/api/designations", {
    designation: newDesignation,
    dist,
  });

  setNewDesignation("");
  fetchDesignations();
};


  // Edit designation
const handleEdit = async () => {
  await axios.put(`https://lionsdirectoryapi.emedha.in/cabinet/api/designations/${editId}`, {
    designation: editDesignation,
  });
  setShowEditModal(false);
  fetchDesignations();
};

const handleDelete = async (id) => {
  await axios.delete(`https://lionsdirectoryapi.emedha.in/cabinet/api/designations/${id}`);
  fetchDesignations();
};


  return (
    <div className="container mt-4">
      <h2 className="text-center" style={{ color: "orange" }}>Cabinet Management</h2>

      {/* Add Designation Form */}
      <div className="d-flex align-items-center justify-content-center mb-3 mt-3  col-md-6">
        <Form.Control
          type="text"
          value={newDesignation}
          onChange={(e) => setNewDesignation(e.target.value)}
          placeholder="Enter Designation"
          style={{height:'38px'}}
        />
        <Button variant="warning" onClick={handleAdd} className="ms-2">Add</Button>
      </div>

      {/* Designation List */}
      <Table bordered hover>
        <thead className="bg-warning text-white">
          <tr>
            <th>#</th>
            <th>Designation</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {designations.slice(pagination.start, pagination.end).map((item, index) => (
            <tr key={item.sno}>
              <td>{index + 1 + pagination.start}</td>
              <td>{item.designation}</td>
              <td>
                <Button
                  variant="primary"
                  className="me-2"
                  onClick={() => {
                    setEditId(item.sno);
                    setEditDesignation(item.designation);
                    setShowEditModal(true);
                  }}
                >
                  Edit
                </Button>
                <Button variant="danger" onClick={() => handleDelete(item.sno)}>Delete</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Designation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            type="text"
            value={editDesignation}
            onChange={(e) => setEditDesignation(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>Close</Button>
          <Button variant="warning" onClick={handleEdit}>Update</Button>
        </Modal.Footer>
      </Modal>

      {/* Pagination */}
      <Pagination page={showPerPage} onChangePagination={onChangePagination} total={designations.length} />
    </div>
  );
};

export default Cabinett;
